import { z } from "zod/v4";
import { memberSummarySchema } from "./member";
import { sessionStatusSchema } from "./session";
import { trainingSlotSchema } from "./slot";

export const trainingSkillLevelSchema = z.enum(["beginner", "intermediate", "advanced"]);

export const clubSquadNextSessionSchema = z.object({
	date: z.coerce.date(),
	end_time: z.string(),
	id: z.string(),
	start_time: z.string(),
});

export const clubSquadSchema = z.object({
	description: z.string().nullable().optional(),
	id: z.string().uuid(),
	max_members: z.number().int(),
	member_count: z.number().int(),
	name: z.string(),
	next_session: clubSquadNextSessionSchema.nullable().optional(),
});

export const clubSquadMembersSchema = z.array(memberSummarySchema);

export const clubSquadSessionSchema = z.object({
	date: z.coerce.date(),
	end_time: z.string(),
	id: z.string().uuid(),
	location_name: z.string().nullable().optional(),
	start_time: z.string(),
	status: sessionStatusSchema,
});

export const trainingGroupSchema = z.object({
	club_id: z.string().uuid(),
	club_location_id: z.string().uuid().nullable().optional(),
	co_trainer: memberSummarySchema.nullable().optional(),
	co_trainer_id: z.string().uuid().nullable().optional(),
	color: z.string().nullable().optional(),
	court_ids: z
		.array(z.string().uuid())
		.nullable()
		.transform((v) => v ?? []),
	created_at: z.coerce.date(),
	description: z.string().nullable().optional(),
	id: z.string().uuid(),
	location_id: z.string().uuid().nullable().optional(),
	location_name: z.string().nullable().optional(),
	max_members: z.number().int(),
	member_count: z.number().int(),
	name: z.string(),
	season_id: z.string().uuid(),
	skill_level: trainingSkillLevelSchema.nullable().optional(),
	skill_level_id: z.string().uuid().nullable().optional(),
	skill_level_name: z.string().nullable().optional(),
	slots: z
		.array(trainingSlotSchema)
		.nullable()
		.transform((v) => v ?? []),
	squad_id: z.string().uuid().nullable().optional(),
	trainer: memberSummarySchema.nullable().optional(),
	trainer_id: z.string().uuid(),
	venue_id: z.string().uuid().nullable().optional(),
});

export const createTrainingGroupSchema = z.object({
	club_location_id: z.string().uuid().nullable().optional(),
	co_trainer_id: z.string().uuid().nullable().optional(),
	color: z.string().nullable().optional(),
	court_ids: z.array(z.string().uuid()).optional(),
	description: z.string().nullable().optional(),
	location_id: z.string().uuid().nullable().optional(),
	max_members: z.number().int().min(1).optional(),
	name: z.string().min(1, "Name is required"),
	season_id: z.string().uuid(),
	skill_level: trainingSkillLevelSchema.nullable().optional(),
	skill_level_id: z.string().uuid().nullable().optional(),
	squad_id: z.string().uuid().nullable().optional(),
	trainer_id: z.string().uuid(),
	venue_id: z.string().uuid().nullable().optional(),
});

export const updateTrainingGroupSchema = z.object({
	club_location_id: z.string().uuid().nullable().optional(),
	co_trainer_id: z.string().uuid().nullable().optional(),
	color: z.string().nullable().optional(),
	court_ids: z.array(z.string().uuid()).optional(),
	description: z.string().nullable().optional(),
	location_id: z.string().uuid().nullable().optional(),
	max_members: z.number().int().min(1).optional(),
	name: z.string().min(1).optional(),
	skill_level: trainingSkillLevelSchema.nullable().optional(),
	skill_level_id: z.string().uuid().nullable().optional(),
	trainer_id: z.string().uuid().optional(),
	venue_id: z.string().uuid().nullable().optional(),
});

export const paginatedGroupsSchema = z.object({
	items: z.array(trainingGroupSchema),
	limit: z.number(),
	offset: z.number(),
	total: z.number(),
});
